import { useTranslation } from 'react-i18next';

export const useChartFormat = () => {
  const { t } = useTranslation('channel-details');

  const getLabel = (tariff: string) => {
    if (tariff.includes('DYNAMIC')) {
      return tariff.replace('DYNAMIC', t('optimizer.configuration.tariff.dynamic').toUpperCase());
    }

    return tariff;
  };

  return {
    getLabel,
  };
};
